export const handleCopyClick = (textToCopy, callback) => {
  // Add input validation
  if (typeof textToCopy !== 'string' || textToCopy.length === 0) {
    callback('error');
    return;
  }

  const isIOS = /ipad|iphone|ipod/i.test(navigator.userAgent) || 
               (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  
  // Enhanced Safari detection
  const isSafari = typeof navigator.vendor === 'string' && 
                  navigator.vendor.includes('Apple') && 
                  !/CriOS|FxiOS|EdgiOS|OPiOS/.test(navigator.userAgent);

  // Feature detection first
  if (!navigator.clipboard || isIOS || isSafari) {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    textarea.setAttribute('readonly', ''); // Prevent keyboard on mobile
    textarea.style.position = "absolute";
    textarea.style.width = '1px'; // Needed for iOS
    textarea.style.height = '1px';
    textarea.style.padding = '0';
    textarea.style.border = 'none';

    document.body.appendChild(textarea);
    
    try {
      // Handle iOS selection quirks
      if (isIOS) {
        const range = document.createRange();
        range.selectNodeContents(textarea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textarea.setSelectionRange(0, 999999);
      } else {
        textarea.select();
      }
      
      // Execute copy
      const success = document.execCommand('copy');
      if (!success) throw new Error('Copy failed');
      callback();
    } catch (err) {
      callback('error');
    } finally {
      document.body.removeChild(textarea);
    }
    return;
  }

  // Modern Clipboard API
  navigator.clipboard.writeText(textToCopy)
    .then(() => callback())
    .catch((err) => {
      // Handle permission denial explicitly
      if (err.name === 'NotAllowedError') {
        // console.warn('Clipboard permission denied');
      }
      callback('error');
    });
};


 export function generateUniqueId(prefix = 'id') {
    const timestamp = Date.now().toString(36);
    const randomNumber = Math.random().toString(36).substring(2, 8);
    return `${prefix}-${timestamp}-${randomNumber}`;
  }
